export default __webpack_public_path__ + "194300de376ba923378b544675ea6fbd.svg";